import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const SortingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DisplayedReviewsRange = styled.span`
  ${theme.typography.labelRegular400}
`;

export const SortByWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  ${theme.typography.labelRegular400}
`;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  cursor: pointer;
`;
